import React from 'react';

const ProfileAcademicTitleListing = ({ data, onEdit, onDelete, isLoading }) => {
    const formatDate = (dateStr) => dateStr ? dateStr.split('-').reverse().join('-') : '-';

    return (
        <div className="table-card">
            {isLoading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <i className="fa-solid fa-circle-notch fa-spin" style={{ marginRight: '8px' }}></i>
                    Đang tải dữ liệu
                </div>
            ) : data.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '60px 20px', color: '#666' }}>
                    <i className="fa-solid fa-award" style={{ fontSize: '60px', color: '#5dade2', marginBottom: '15px' }}></i>
                    <h3 style={{ color: '#e74c3c', margin: '0 0 10px 0' }}>Chưa có dữ liệu học vị và chức danh</h3>
                </div>
            ) : (
                <div style={{ overflowX: 'auto', width: '100%' }}>
                    <table className="custom-table" style={{ width: '100%', minWidth: '1000px' }}>
                        <thead>
                            <tr>
                                <th width="5%" style={{ textAlign: 'center' }}>STT</th>
                                <th width="15%">CHỨC DANH</th>
                                <th width="15%">HỌC HÀM</th>
                                <th width="10%">HỌC VỊ</th>
                                <th width="20%">ĐƠN VỊ CÔNG TÁC</th>
                                <th width="20%" style={{ textAlign: 'center' }}>NGÀY CẤP BẰNG / BỔ NHIỆM</th>
                                <th width="5%" style={{ textAlign: 'center' }}>HIỆN TẠI</th>
                                <th width="10%" style={{ textAlign: 'center' }}>CHỨC NĂNG</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={item.Id}>
                                    <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                    <td style={{ fontWeight: '500', color: '#2c3e50' }}>{item.TitleName || '-'}</td>
                                    <td style={{ fontWeight: '500', color: '#8e44ad' }}>{item.AcademicRank || '-'}</td>
                                    <td style={{ fontWeight: '500', color: '#0056b3' }}>{item.DegreeName}</td>
                                    <td>{item.UnitName}</td>
                                    <td style={{ textAlign: 'center' }}>
                                        {formatDate(item.DegreeDate)} / {formatDate(item.TitleDate)}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        {item.IsCurrent && <i className="fa-solid fa-circle-check" style={{ color: '#2ecc71', fontSize: '18px' }}></i>}
                                    </td>
                                    <td>
                                        <div className="action-group" style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                            <div className="icon-wrapper edit-wrapper" onClick={() => onEdit(item)} title="Sửa" style={{ cursor: 'pointer' }}>
                                                <i className="fa-solid fa-pen edit-icon"></i>
                                            </div>
                                            <div className="icon-wrapper delete-wrapper" onClick={() => onDelete(item.Id)} title="Xóa" style={{ cursor: 'pointer' }}>
                                                <i className="fa-solid fa-trash delete-icon"></i>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default ProfileAcademicTitleListing;